module.exports = __webpack_public_path__ + "img/dhc_dahordescoin.e34b5e7.png";